import { Progress } from "@/components/ui/progress"

interface ApexPointsProps {
  currentPoints: number
  nextTierPoints: number
  tierName: string
  className?: string
}

export function ApexPoints({ 
  currentPoints, 
  nextTierPoints, 
  tierName,
  className 
}: ApexPointsProps) {
  const progress = (currentPoints / nextTierPoints) * 100
  const remainingPoints = nextTierPoints - currentPoints
  
  return (
    <div className={className}>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              {currentPoints.toLocaleString()}
            </h3>
            <p className="text-sm text-muted-foreground">Apex Points</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-muted-foreground">
              {remainingPoints > 0 ? (
                <>
                  <span className="text-primary font-medium">
                    {remainingPoints.toLocaleString()}
                  </span>
                  {' '}to {tierName}
                </>
              ) : (
                <span className="text-accent font-medium">Tier Unlocked</span>
              )}
            </p>
          </div>
        </div>
        
        <div className="space-y-2">
          <Progress 
            value={progress} 
            className="h-2 bg-muted"
          />
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>0</span>
            <span>{nextTierPoints.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  )
}